import React from 'react';
import styled from '@emotion/styled';

import { useIsFeatureFlagEnabled } from '../../contexts/feature-flag-context';
import { GigValueFilter } from './GigValueFilter';
import { GigLastEventFilter } from './GigLastEventFilter';
import { BoardPriorityFilter } from './BoardPriorityFilter';

const FiltersWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 20px;
  flex-direction: row-reverse;
`;

const ValueFilterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const BoardFilters = ({ appliedFilters, handleApplyFilters, priorityFilter, handleApplyPriorityFilter }) => {
  const priorityFiltersFlag = useIsFeatureFlagEnabled("vip-fe-priority-filters");
  
  return (
    <FiltersWrapper style={priorityFiltersFlag ? {} : {justifyContent: 'space-between'}}>
      <ValueFilterWrapper>
        <GigValueFilter
          title={'Filter By Value'}
          appliedFilters={appliedFilters}
          onClickApply={handleApplyFilters}
        />
      </ValueFilterWrapper>
      <GigLastEventFilter
        title={'Last Event'}
        appliedFilters={appliedFilters}
        onClickApply={handleApplyFilters}
      />
      {priorityFiltersFlag && (
      <BoardPriorityFilter
        priorityFilter={priorityFilter}
        onClickApply={handleApplyPriorityFilter}
      />)}
    </FiltersWrapper>
  );
};

export default BoardFilters;
